import React, { useEffect, useRef, useState } from 'react'
import * as echarts from 'echarts';
import { usePrincipal } from '../../../hooks/Principal/usePrincipal';
import SkeletonGraficoBarras from './SkeletonGraficoBarras';

const ContenedorAlertas = () => {
  const refGrafico = useRef(null)
  const refInterval = useRef(null)
  const refChart = useRef(null)
  const hookPrincipal = usePrincipal()
  const [estaCargando, setEstaCargando] = useState(false)

  useEffect(() => {
    (async () => {
      setEstaCargando(true)
      setTimeout(async () => {
        await funcionProcesamiento()
        setEstaCargando(false)
        refInterval.current = setInterval(async () => {
          await funcionProcesamiento()
        }, 10000);
      }, 500);
    })()

    return () => {
      clearInterval(refInterval.current)
    }
  },[])

  const funcionProcesamiento = async () => {
    const alertasPorEmpresa = await hookPrincipal.listarAlertasPorEmpresa()
    crearGrafico(alertasPorEmpresa)
  }

  const crearGrafico = (alertasPorEmpresa) => {
    const alertas = alertasPorEmpresa.alertas
    const empresas = alertasPorEmpresa.empresas
    const arrEmpresas = Object.keys(empresas)
    const arrAlertas = Object.keys(alertas)

    !refChart.current && (refChart.current = echarts.init(refGrafico.current));

    const seriesAlertas = arrAlertas.map(data => ({
      name: data,
      type: "bar",
      stack: 'Ad',
      // barWidth: 25,
      emphasis: {
        focus: 'series'
      },
      data: Object.values(empresas).map(data2 => data2.find(elem => elem.nomAlerta == data)?.cantidadAlerta || 0),  // CUANTAS ALERTAS TIENE POR CADA EMPRESA
    }))

    const option = {
      tooltip: {
        trigger: 'axis',
        confine: true,
        axisPointer: {
          type: 'shadow'
        },
        formatter: function (params) {
          let total = params.reduce((sum, item) => sum + Number(item.value), 0);
          let tooltipText = `${params[0].axisValue} <br/>`;
          params.forEach((item) => {
            tooltipText += `${item.marker} ${item.seriesName}: ${item.value} <br/>`;
          });
          tooltipText += `<b>Total Alertas: ${total}</b>`;
          return tooltipText;
        },
      },
      legend: {
        textStyle: {
          color: 'white'
        },
        bottom: 0
      },
      grid: {
        top: '3%',
        left: '3%',
        right: '4%',
        bottom: '20%',
        containLabel: true
      },
      xAxis: [
        {
          type: 'category',
          data: arrEmpresas,
          axisLabel: {
            interval: 0,  // Muestra todas las etiquetas sin saltarse ninguna
            rotate: 45,   // Rota las etiquetas para que no se superpongan (prueba con 30, 45 o 90)
            fontSize: 12, // Ajusta el tamaño del texto
            width: 50,
            overflow: "truncate",
            color: 'white',
          },
          tooltip: {
            show: true, // 🔹 Muestra el tooltip cuando pasas el mouse sobre el label
          },
        }
      ],
      yAxis: [
        {
          type: 'value', 
        }
      ],
      series: seriesAlertas,
    };
  
    refChart.current.setOption(option);
  }

  return(
    <>
      {
        estaCargando 
        ? <SkeletonGraficoBarras></SkeletonGraficoBarras> 
        : <></>
      }
      <div ref={refGrafico} className={`w-full h-full ${estaCargando ? 'invisible' : ''}`}></div>
    </>
  )
}

export default ContenedorAlertas